import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/cn.js';
export function Shell({ sideCollapsed = false, railCollapsed = false, noRail = false, className, children, ...rest }) {
    return (_jsx("div", { ...rest, className: cn('portal-shell', sideCollapsed && 'is-side-collapsed', railCollapsed && 'is-rail-collapsed', noRail && 'no-rail', className), children: children }));
}
export function Side({ children, className, ...rest }) {
    return (_jsx("div", { ...rest, className: cn('portal-side', className), children: children }));
}
export function Top({ children, className, ...rest }) {
    return (_jsx("header", { ...rest, className: cn('portal-top', className), children: children }));
}
export function Main({ children, className, scrollClassName, ...rest }) {
    return (_jsx("main", { ...rest, className: cn('portal-main', className), children: _jsx("div", { className: cn('portal-main-scroll', scrollClassName), children: children }) }));
}
export function Rail({ children, className, ...rest }) {
    return (_jsx("aside", { "aria-label": "Side rail", ...rest, className: cn('portal-rail', className), children: children }));
}
